import styled from 'styled-components';

const ContainerStyled = styled.div`
  padding: 0px;
  display: flex;
  align-items: flex-start;
  word-wrap: normal;
  img {
    width: 40px;
  }
`;

const TextStyled = styled.div`
  padding: 0px;
  margin-left: 15px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-top: ${props => (props.recarga ? '8px' : '0px')};
  div:first-child {
    margin-bottom: 10px;
  }
`;

export { ContainerStyled, TextStyled };
